import { combineReducers } from 'redux';
import initialState from './initialState';
import codePanelReducer from './store/CodePanel/reducer';
import operationsMenuReducer from './store/OperationsMenu/reducer';
import navigationBarReducer from './store/NavigationBar/reducer';
import previewPanelReducer from './store/PreviewPanel/reducer';
import exampleGalleryReducer from './store/ExampleGallery/reducer';
import eventPanelReducer from './store/EventPanel/reducer';
import environmentSettingReducer from './store/EnvironmentSetting/reducer';

const allSubReducers = combineReducers({
  CodePanel: codePanelReducer,
  OperationsMenu: operationsMenuReducer,
  NavigationBar: navigationBarReducer,
  PreviewPanel: previewPanelReducer,
  ExampleGallery: exampleGalleryReducer,
  EventPanel: eventPanelReducer,
  EnvironmentSetting: environmentSettingReducer,
});

// eslint-disable-next-line default-param-last -- this is Redux's way, ignore it
const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return allSubReducers(state, action);
  }
};

export default rootReducer;
